import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BackToTopIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BackToTopIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 2C5.33579 2 5 2.33579 5 2.75C5 3.16421 5.33579 3.5 5.75 3.5H18.25C18.6642 3.5 19 3.16421 19 2.75C19 2.33579 18.6642 2 18.25 2H5.75ZM6.32775 11.967C6.02401 12.2674 5.53155 12.2674 5.22781 11.967C4.92406 11.6666 4.92406 11.1796 5.22781 10.8791L11.45 4.7253C11.6013 4.57569 11.7994 4.50059 11.9977 4.5L12 4.5L12.0023 4.5C12.1069 4.50031 12.2067 4.52104 12.2977 4.55837C12.3895 4.59591 12.4754 4.65155 12.55 4.7253L18.7722 10.8791C19.0759 11.1796 19.0759 11.6666 18.7722 11.967C18.4685 12.2674 17.976 12.2674 17.6723 11.967L12.7778 7.12632L12.7778 21.2308C12.7778 21.6556 12.4296 22 12 22C11.5704 22 11.2222 21.6556 11.2222 21.2308L11.2222 7.12632L6.32775 11.967Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BackToTopIcon;
